import { storyPageContent } from "../data/services";
import { motion } from "framer-motion";
import ServicesBanner from "../components/common/ServicesBanner";
import userImg from "../assets/icons/CLIENTImg.png";
import OpportunitiesImg from "../assets/icons/OPPORTUNITIESImg.png";
import ChallengesImg from "../assets/icons/CHALLENEGS.jpg";
import SuccessImg from "../assets/icons/SUCCESS.jpg";
const SuccessStory4 = () => {
  // const story = getSuccessStoryById(2);

  const {bannerTitle, bannerImage } =
    storyPageContent;
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };
  const cards = [
    {
      title: "クライアントの背景",
      img: userImg,
      description:
        "お客様は日本国内で副業ビジネスを展開し、農業用途向け産業用無人ヘリコプターの製造・販売にも注力されています。また、お客様は単なる製造・販売にとどまらず、地域ごとの特約店ネットワークを構築することで、販売・導入支援・保守まで一貫したエコシステムを形成されています。",
    },
    {
      title: "機会",
      img: OpportunitiesImg,
      description:
        "お客様が現在直面している課題は、旧来のシステム基盤で構築された販売・管理・保守システムを、モダンな開発環境であるLaravel（Bootstrap対応）へと刷新することを検討されていました。この移行において、お客様は現行システムのコードを解析・理解できる技術力があり、新システムへのスムーズな移行を支援する信頼できる開発パートナーを求めていました。",
    },
    {
      title: "課題",
      img: ChallengesImg,
      description:
        "本プロジェクトにおいては、多くの技術的・運用的なハードルが存在していました。現行システムの業務ロジックに関する明確なドキュメントや引き継ぎ資料がほとんど存在しておらず、仕様の理解が困難でした。システムの挙動を正確に把握するには、実際の運用事例やデータフローの詳細な把握が不可欠でしたが、その情報が共有されていない、もしくは断片的でした。開発・移行作業を進めるうえで必要となる実データへのアクセスが制限されていたため、挙動の検証や移行設計に支障をきたしました。テスト用データも十分に提供されておらず、開発側でシナリオを再現・検証するのに多大な時間を要しました。旧システムには適切な入力バリデーションやデータフォーマットチェックが実装されておらず、ユーザーごとに不整合なデータが入力されているケースも多々見られました。 上記のような技術的・運用的な障壁がある中で、限られた納期内でシステムの再設計と開発を完了させる必要があり、非常にチャレンジングなプロジェクトでした。",
    },
    {
      title: "解決策と成功",
      img: SuccessImg,
      description:
        "旧システムでは、ユーザーインターフェースが複雑かつ非直感的で、特約店や社内ユーザーにとって操作性に課題がありました。\n新システムでは以下の改善を実施：\n＊ユーザーフローを再構築し、画面遷移の簡素化\n＊Bootstrapを活用したレスポンシブ対応\n＊情報の視認性と入力の一貫性を強化\n＊パフォーマンスのボトルネックを特定・解消\n＊共通機能を抽象化したコンポーネントの構築\n＊コードの再利用性と保守性の向上\n結果として、新システムは構造的に整理され、今後の拡張やメンテナンスが容易となりました。\nこれらの取り組みにより、お客様側が議論や知識共有に多くのリソースを割かずとも、スムーズなシステム移行と納期通りの納品を実現しました。\nUX、保守性、拡張性すべての面において、旧システムを上回る成果を上げることができました。", 
    },
  ];
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 mb-5 mx-auto">
      {/* Banner Section */}
      <ServicesBanner title={bannerTitle} heroImage={bannerImage} />
      <div className="max-w-5xl mx-auto md:px-10 lg:px-10 lg:max-w-fit">
        <div className="flex justify-center items-center">
          {/* Header Section */}
          <div className="m-5">
            <h1 className="text-3xl font-bold mt-2">
            <span>Webアプリケーションの基盤移行</span>
            </h1>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-10 w-full max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:shadow-blue-100 p-10 transition duration-300 ease-in-out"
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-16 h-16 rounded-full border border-gray-200"
                />
                <h3 className="text-2xl font-semibold text-blue-700">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-800 leading-relaxed text-lg">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory4;
